/**
 * Заготовки дел (ТЗ FR-45).
 *
 * Заказчик назвал самое частое сочетание (ответ на вопрос 37):
 * нет имущества, не работает, не в браке, нет детей. Заготовка выставляет
 * именно эти признаки — ввод сокращается на четыре блока.
 *
 * Заготовка НЕ трогает персональные данные и не удаляет уже введённое:
 * применять её имеет смысл к пустому делу, и интерфейс предлагает её только
 * тогда (см. `isPresetApplicable`).
 */

import type { CaseProfile } from './types/profile.js';

export interface CasePreset {
  id: string;
  title: string;
  description: string;
  apply: (profile: CaseProfile) => CaseProfile;
}

/** Дело считается пустым, если ни один из затрагиваемых блоков не заполнен. */
export function isPresetApplicable(profile: CaseProfile): boolean {
  const p = profile.property;
  const propertyRows =
    p.realty.length + p.vehicles.length + p.accounts.length + p.shares.length + p.securities.length + p.valuables.length;

  return (
    propertyRows === 0 &&
    profile.deals.items.length === 0 &&
    profile.family.statuses.length === 0 &&
    profile.family.spouses.length === 0 &&
    profile.family.children.length === 0 &&
    !profile.income.employed &&
    profile.income.organizations.length === 0
  );
}

export const TYPICAL_CASE: CasePreset = {
  id: 'typical',
  title: 'Типовое дело',
  description: 'Нет имущества, не работает, не в браке, нет детей',
  apply: (profile) => ({
    ...profile,
    property: { ...profile.property, hasProperty: false },
    deals: { hasDeals: false, items: [] },
    family: { statuses: ['single'], spouses: [], children: [] },
    income: {
      ...profile.income,
      employed: false,
      employerName: '',
      employerInn: '',
      monthlySalary: 0,
      salaryConfirmation: '',
      hasSocialPayments: false,
      socialPaymentsDescription: '',
      isEntrepreneur: false,
      hasOrganizations: false,
      organizations: [],
    },
  }),
};

export const CASE_PRESETS: CasePreset[] = [TYPICAL_CASE];
